<div class="spinner-container">
  <div class="spinner">
    <img width="80px" src="assets/img/loading.gif">
  </div>
</div>
